var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m218.8 320.7-139 87.7v733.3h348V725c0-12.4 6.6-23.8 17.3-30s23.9-6.2 34.7 0c10.7 6.2 17.3 17.6 17.3 30v417.3h139.3V57.6L288.7 276.9l-70 43.7ZM1012.2 503.7V818c0 9.7-5.2 18.7-13.6 23.6s-18.8 4.9-27.2 0-13.6-13.8-13.6-23.6V469.8L687.6 299.3v843.1h432.7v-570l-108-68.7Z"
  })));
};
export default SvgLocation;